import React from 'react';
import NO_AVA from 'styles/img/no-ava-card.png'
import AVERAGE_ICON from 'styles/img/average.svg';
import GOOD_ICON from 'styles/img/good.svg';
import EXELENT_ICON from 'styles/img/excellent.svg';
import {inject, observer} from 'mobx-react';
import classNames from 'classnames';
import Form from './Form';
import { Editor } from 'react-draft-wysiwyg';
import { EditorState, ContentState } from 'draft-js';
import {linkComponentDecorator} from 'blocks/LinkRenderComponent'
import htmlToDraft from 'html-to-draftjs';
@inject('user')
@inject('workshopDetails')
@observer
export default class Response extends React.Component {


  state = {editMode: false};

  switchEditMode = e => {
    this.setState({editMode: true})
  };

  handleClose = () => {
    this.setState({editMode: false})
  };

  htmlToDrafJs = html => {
    const {contentBlocks, entityMap} = htmlToDraft(html);
    const contentState = ContentState.createFromBlockArray(contentBlocks, entityMap);
    return EditorState.createWithContent(contentState);
  };

  render(){
    let iconType = null;
      if (this.props.el.answer_score === 'average')
        iconType = AVERAGE_ICON;
      if (this.props.el.answer_score === 'good')
        iconType = GOOD_ICON;
      if (this.props.el.answer_score === 'excellent')
        iconType = EXELENT_ICON;
    return (
        this.state.editMode ?
        <Form response={{id: this.props.el.id,
          text: this.props.el.text,
          documents: [],
          status: this.props.question.status,
          attachments: this.props.el.attachments || [],
          attachments_attributes: []}}

              handleClose={this.handleClose}
              />
        :
    <div className="answers" style={{display: this.state.editMode ? 'none' : 'block' }}>
      <div className={classNames('answer-item',
        {feedback: (this.props.user.getUser().id !== this.props.el.user.id)})}>
        <div className="answer-item-head">
          <div className="answer-item-avatar">
            {this.props.el.user.avatar_url ?
              <img src={this.props.el.user.avatar_url} alt="avatar"/> :
              <img src={NO_AVA} alt="avatar"/>
            }
          </div>
          <div className="answer-item-info">
            <p className="name">{this.props.el.user.full_name}</p>
            <p className="type">Response Posted</p>
          </div>
          <div className="answer-item-date">{this.props.el.updated_at}</div>
        </div>
        <div className="answer-item-content">
          <div className="answer-item-content-holder">
            {this.props.el.answer_score ?
              <img src={iconType} style={{width: 200}}/> :
              <Editor
                editorState={this.htmlToDrafJs(this.props.el.text || '')}
                toolbarClassName="nonDispayed"
                wrapperClassName="noneBorder"
                customDecorators={[linkComponentDecorator]}
                editorClassName="noneBorder"
                placeholder="Description editor…"
                options={null}
                readOnly={true}
              />
            }
            <span className="border"/>
            <ul className="file-list">
              {this.props.el.attachments.map((el, i) =>
                <a className="file-link-active"
                   key={i}
                   href={el.document_url}
                   download={true}>
                <li className="file-item" >
                  <i className="file-icon ic-file-ico"/>
                  <div className="file-link">
                   {el.document_file_name}

                  </div>
                </li>
                </a>
              )}
            </ul>
            { this.props.el.text && this.props.workshopDetails.workshop.modules[this.props.moduleId].status !== 'module_completed' &&
              <div className="answer-item-edit btn-holder customize-hiden-edit">
                <span className="btn bordered empty grey-empty"
                      onClick={this.switchEditMode}>edit</span></div>
            }
          </div>
        </div>
      </div>

    </div>

    )

  }
}



// WEBPACK FOOTER //
// ./src/components/providers/online_workshop_details/question/responces/Response.jsx